import { IRequestPharmacy, RequestStatus } from '../Request/types';

export interface IRequestPharmacyApprovalRow extends IRequestPharmacy {
    edit: boolean;
    error: number;
    approved: boolean;
}

/** SHER-489: manager must actively approve each line — do not copy requested qty. */
export function initPharmacyApprovalState(
    requestsPharmacy: IRequestPharmacy[],
    { completed = false }: { completed?: boolean } = {},
): IRequestPharmacyApprovalRow[] {
    return requestsPharmacy.map((req) => {
        const savedApproved = req.amountApproved > 0;
        return {
            ...req,
            amountApproved: completed ? req.amountApproved : savedApproved ? req.amountApproved : 0,
            edit: false,
            error: 0,
            approved: completed || savedApproved,
        };
    });
}
